import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../common/Header';
import blendersImage from '../../assets/images/blender.jpg';
import dispenserImage from '../../assets/images/dispenser.jpg';
import acImage from '../../assets/images/AC.jpg';
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { useLanguage } from '../../store/languageContext';
import translate from '../../utils/translation';
const Services = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const services = [
        {
            title: translate[language]['serviceTitle1'],
            description: translate[language]['serviceText3'],
            image: blendersImage
        },
        {
            title: translate[language]['serviceTitle2'],
            description: translate[language]['serviceText3'],
            image: dispenserImage
        },
        {
            title: translate[language]['serviceTitle3'],
            description: translate[language]['serviceText3'],
            image: acImage
        },
    ];

    return (
        <section id="services" ref={sectionRef} className="container mx-auto landing-section pb-[50px] flex flex-col" >
            <Header text={translate[language]["servicesHeader"]} />
            <div className="flex flex-col md:flex-row gap-8 flex-1">
                <div className="md:w-1/3 opacity-75">
                    <motion.img
                        key={activeIndex}
                        src={services[activeIndex].image}
                        alt={services[activeIndex].title}
                        className="w-full h-full object-cover rounded-[50px] shadow-lg"
                        initial={{ y: 150, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                        viewport={{ once: true }}
                    />
                </div>
                <div className="md:w-2/3 flex flex-col justify-between items-center">
                    <div className='w-1/2'>
                        <motion.h2
                            initial={{ y: 100, opacity: 0 }}
                            whileInView={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                            viewport={{ once: true }}
                            className='text-[60px] leading-[60px] font-semibold mb-4'>
                            {translate[language]["servicesTitle1"]}
                        </motion.h2>
                        <motion.p
                            initial={{ y: 50, opacity: 0 }}
                            whileInView={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                            viewport={{ once: true }}
                            className='opacity-[0.5]'>
                            {translate[language]["servicesTitle2"]} <br />
                            {translate[language]["servicesTitle3"]}
                        </motion.p>
                    </div>
                    <motion.div
                        initial={{ y: 100, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                        viewport={{ once: true }}
                        className='w-1/2'>
                        {services.map((service, index) => (
                            <div key={index} className={`font-semibold py-2 ${language === 'ar' ? 'border-r-[2px] pr-[36px]' : 'border-l-[2px] pl-[36px]'} ${activeIndex === index ? 'border-[#589EEE]' : ''}`}>
                                <div className='flex flex-col pb-4 border-b'>
                                    <div
                                        onClick={() => setActiveIndex(index)}
                                        className={`w-full flex justify-between items-center pb-[15px] cursor-pointer ${language === 'ar' ? 'text-right' : 'text-left '}`}
                                    >
                                        <span className="uppercase flex-1 text-2xl">
                                            {service.title}
                                        </span>
                                        <span className={`border size-[36px] min-w-[36px] rounded-full p-1 flex items-center justify-center ${activeIndex === index ? 'bg-[#589EEE] text-white' : ''}`}>
                                            {language === 'ar' ? <GoArrowLeft /> : <GoArrowRight />}
                                        </span>
                                    </div>
                                    {activeIndex === index && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.5 }}
                                            className="overflow-hidden "
                                        >
                                            <p className='opacity-50'>{service.description}</p>
                                        </motion.div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export { Services };